import React from 'react';
import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const CustomTick = () => (
  <Box
    sx={{
      width: 18,
      height: 18,
      border: '2px solid #1C2F3A',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mr: 1,
    }}
  >
    <CheckIcon sx={{ fontSize: 14, color: '#1C2F3A', fontWeight: 900 }} />
  </Box>
);

const RadioPillSelectorComponent = ({
  name,
  options = [],
  value,
  onChange,
  multiple = false,
  isMobile = false,
  layoutVariant = 'default',
}) => {
  const isAccountLayout = layoutVariant === 'account';
  const normalizedValue =
    multiple && !Array.isArray(value) ? (value ? [value] : []) : value;
  const mobilePaddingX = isAccountLayout ? 1.5 : 2;
  const mobilePaddingY = isAccountLayout ? 0.75 : 0.5;
  const mobileFontSize = isAccountLayout ? '0.75rem' : '0.4375rem';
  const mobileMinHeight = isAccountLayout ? '40px' : '25px';

  const handleChange = (_, newValue) => {
    if (multiple) {
      onChange(name, Array.isArray(newValue) ? newValue : []);
      return;
    }

    if (newValue !== null) {
      onChange(name, newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={normalizedValue}
      exclusive={!multiple}
      onChange={handleChange}
      sx={{
        display: 'flex',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        gap: 1,
        height: isMobile ? 'auto' : '51px',
        width: isMobile ? '100%' : 'fit-content',
        ml: 'auto',
        justifyContent: isAccountLayout && isMobile ? 'flex-end' : 'flex-start',
        '& .MuiToggleButton-root': {
          display: 'flex',
          alignItems: 'center',
          borderRadius: '1.2rem',
          border: '1px solid #D1D1D1',
          textTransform: 'none',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          lineHeight: '100%',
          px: isMobile ? mobilePaddingX : 3,
          py: isMobile ? mobilePaddingY : 1,
          fontSize: isMobile ? mobileFontSize : '1rem',
          color: '#757575',
          backgroundColor: 'white',
          '&.Mui-selected': {
            backgroundColor: '#C7CA00',
            color: '#1C2F3A',
            fontWeight: 600,
            borderColor: '#C7CA00',
          },
        },
      }}
    >
      {options.map((opt, i) => {
        const isSelected = multiple
          ? normalizedValue.includes(opt)
          : normalizedValue === opt;
        return (
          <ToggleButton
            key={i}
            value={opt}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              minHeight: isMobile ? mobileMinHeight : '51px',
            }}
          >
            {isSelected ? (
              <CustomTick />
            ) : (
              <CheckBoxOutlineBlankIcon
                sx={{ fontSize: '1.1rem', color: '#BDBDBD', mr: 1 }}
              />
            )}
            {opt}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default RadioPillSelectorComponent;
